import React from "react";
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import snackbarStyles from "./snackbarStyles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { HashLink as Link } from "react-router-hash-link";
import { IconButton, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MuiLink from "@mui/material/Link";

export type CustomSnackbarProps = {
  buttonText?: string;
  buttonType?: "link" | "function";
  buttonLink?: string;
  buttonTarget?: string;
  buttonFunction?: () => void;
  isNonInteractive?: boolean;
  linkIsExternal?: boolean;
};

export const CustomSnackbar = React.forwardRef<HTMLDivElement, CustomSnackbarProps & CustomContentProps>(
  (
    {
      message = "Änderung wurde gespeichert",
      variant,
      style,
      buttonText = "Rückgängig",
      buttonType = "link",
      buttonLink,
      buttonTarget = "_blank",
      buttonFunction,
      isNonInteractive = false,
      linkIsExternal = false,
    },
    ref
  ) => {
    const { closeSnackbar } = useSnackbar();
    const isError = variant === "error";
    const hasAction =
      !isNonInteractive &&
      ((buttonType === "link" && Boolean(buttonLink)) ||
        (buttonType === "function" && Boolean(buttonFunction)));
    return (
      <SnackbarContent ref={ref} style={style}>
        <Paper sx={[snackbarStyles.assignedUserToast, isError ? snackbarStyles.errorToast : null]}>
          <Grid
            container
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid sx={!hasAction ? snackbarStyles.message : undefined} size={!hasAction ? 10 : 6}>
              {message}
            </Grid>
            {hasAction && (
              <>
                <Grid sx={snackbarStyles.alignRight} size={4}>
                  {buttonType === "link" && buttonLink && (
                    <Button
                      component={linkIsExternal ? MuiLink : Link}
                      sx={isError ? snackbarStyles.errorButton : snackbarStyles.revertButton}
                      href={buttonLink}
                      to={buttonLink}
                      target={buttonTarget}
                    >
                      {buttonText}
                    </Button>
                  )}
                  {buttonType === "function" && buttonFunction && (
                    <Button
                      sx={isError ? snackbarStyles.errorButton : snackbarStyles.revertButton}
                      onClick={buttonFunction}
                    >
                      {buttonText}
                    </Button>
                  )}
                </Grid>
              </>
            )}
            <Grid sx={snackbarStyles.alignRight} size={2}>
              <IconButton
                sx={isError ? snackbarStyles.errorButton : undefined}
                onClick={() => {
                  closeSnackbar();
                }}
                size="large"
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Paper>
      </SnackbarContent>
    );
  }
);
